import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs";
import { getMetaValue } from "../plugins/src/metadata"

// Connects to data-controller="background-image-sortables"
export default class extends Controller {

  connect() {
    Sortable.create(this.element, {
      onEnd: this.onEnd.bind(this),
      animation: 150,
      handle: ".sortable-handle",
      forceFallback: true, // Force fallback for better grid support
    });
  }

  onEnd(event) {
    let url = event.item.dataset.sortablePath
    let data = {
      attachment: {
        attachment_order_position: event.newIndex,
      }
    }

    fetch(url, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": getMetaValue("csrf-token"),
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .catch(error => console.error(error));
  }

}
